import Status from 'lib/Status';
import { CreativeStatus } from 'components/common/types/Creative.types';
import { StatusIconProps } from './StatusIcon.types';

const StatusIcon: React.FC<StatusIconProps> = ({ statusCode }) => {
  const statusCodeToBadgeConfigMap = {
    [CreativeStatus.APPROVED]: <Status status="Approved" backgroundColour="bg-green-100" textColour="text-green-900" />,
    [CreativeStatus.PENDING]: <Status status="Pending" backgroundColour="bg-yellow-100" textColour="text-yellow-950" />,
    [CreativeStatus.REJECTED]: (
      <Status status="Rejected" backgroundColour="bg-pinkRed-100" textColour="text-pinkRed-900" />
    ),
    [CreativeStatus.FLAGGED]: (
      <Status status="Flagged" backgroundColour="bg-neutral-100" textColour="text-neutral-900" />
    ),
    [CreativeStatus.INACTIVE]: (
      <Status status="Inactive" backgroundColour="bg-pinkRed-100" textColour="text-pinkRed-900" />
    ),
    [CreativeStatus.UPLOADED]: (
      <Status status="Uploaded" backgroundColour="bg-primary-100" textColour="text-primary-600" />
    ),
    [CreativeStatus.DELETED]: (
      <Status status="Deleted" backgroundColour="bg-pinkRed-100" textColour="text-pinkRed-900" />
    ),
    [CreativeStatus.RESTORED]: <Status status="Restored" backgroundColour="bg-green-100" textColour="text-green-900" />,
    [CreativeStatus.SENT_FOR_APPROVAL]: (
      <Status status="Sent for approval" backgroundColour="bg-yellow-100" textColour="text-yellow-950" />
    ),
  };

  return statusCodeToBadgeConfigMap[statusCode];
};

export default StatusIcon;
